import { reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { toast, variant } from '@/core/helper/utility'
import { httpStatusCode } from '@/core/helper/httpStatusCode';
import { GetAll, GetMessagesById, Create } from '@/infrastructure/repositories/conversationRepository';

export const useConversation = () => { 
    var filter = reactive({ });

    var conversation = ref({
        id: null,
        guid: null,
        idContact: null,
        contact: {
            guid: null,
            name: null,
            phone: null,
            photo: null
        },
        idChannel: null,
        channel: null,
        lastMessage: null,
        messages: [],
        createdDate: null,
        createdBy: null,
        updatedDate: null,
        updatedBy: null,
        deletedDate: null,
        deletedBy: null,
        enabled: false
    });

    const beginConversationInitialState = {
        idContact: null,
        idBrand: null,
        idChannelAccount: null,
    };

    var beginConversation = reactive({ 
        ...beginConversationInitialState 
    });

    const beginConversationRules = {
        idContact: {
            required
        },
        idBrand: {
            required
        },
        idChannelAccount: {
            required
        }
    };

    var isCreateChatOpen = ref(false);
    var isCreateLoading = ref(false);
    var conversationLoading = ref(false);
    var messageLoading = ref(false);
    var conversations = ref([]);
    var messages = ref([]);

    const validate$ = useVuelidate(beginConversationRules, beginConversation, { $scope: false });

    const onCreateHandle = async () => {
        try {
            const isValid = await validate$.value.$validate();
            if(!isValid){
                return;
            }

            isCreateLoading.value = true;
            const response = await Create(beginConversation);

            if(response.status == httpStatusCode.OK){
                toast({
                    variant: variant.success,
                    title: response.data.title,
                    body:  response.data.message
                });

                if(!conversations.value.some(c => c.id == response.data.value.id)){
                    conversations.value.push(response.data.value);
                }
                
                Object.assign(beginConversation, beginConversationInitialState);
                validate$.value.$reset();
                isCreateChatOpen.value = false;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }

            isCreateLoading.value = false;
        } catch (error) {
            isCreateLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Conversations',
                body: 'Could not create conversation, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    };

    const getConversations = async () => {
        try {
            conversationLoading.value = true;

            const response = await GetAll(filter);

            if(response.status == httpStatusCode.OK){
                conversations.value = response.data.value;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }

            conversationLoading.value = false;
        } catch (error) {
            conversationLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Conversations',
                body: 'Could not get conversation list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    const getMessages = async (idConversation) => {
        try {
            messageLoading.value = true;

            const response = await GetMessagesById(idConversation);
            
            if(response.status == httpStatusCode.OK){
                conversation.value.messages = response.data.value;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }

            messageLoading.value = false;
        } catch (error) {
            messageLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Messages',
                body: 'Could not get messages list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    };

    return {
        validate$,
        conversations,
        messages,
        conversation,
        beginConversation,
        messageLoading,
        isCreateChatOpen,
        isCreateLoading,
        conversationLoading,
        getConversations,
        onCreateHandle,
        getMessages
    }
}